<template>
  <section class="p-election2026__section">
    <h2 class="p-election2026__section-title">
      {{ title }}
    </h2>

    <ul class="p-election2026__news">
      <li v-for="item in items" :key="item.id" class="p-election2026__news-item">
        <a
          :href="item.url"
          class="p-election2026__news-link"
          :title="item.title"
          @click="trackNewsClick(item)"
        >
          <LazyImage
            v-if="item.cover"
            class="p-election2026__news-cover"
            :src="item.cover"
            :alt="item.caption"
          />
          <span v-else class="p-election2026__news-cover" aria-hidden="true" />
          <span class="p-election2026__news-body">
            <span class="p-election2026__news-title">{{ item.title }}</span>
            <span class="p-election2026__news-meta">
              <span
                v-if="item.category"
                class="p-election2026__news-cate"
                :class="{ 'p-election2026__news-cate--politics': item.category === '政治' }"
              >{{ item.category }}</span>
              <time :datetime="item.publishAtIso || null">{{ item.publishAt }}</time>
            </span>
          </span>
        </a>
      </li>
    </ul>

    <!-- 導到主站專題頁（預設版型），整頁載入，見 constants.js 的 NEWS_MORE_URL -->
    <a
      v-if="showMore"
      :href="moreLink"
      class="p-election2026__news-more"
      title="查看更多相關新聞"
      @click="trackMoreClick"
    >
      看更多
      <svg viewBox="0 0 8 15" width="8" height="12" fill="currentColor" aria-hidden="true">
        <path d="M7.712 8.243l-6.034 6.45a.938.938 0 01-1.39 0 1.102 1.102 0 010-1.486L5.628 7.5.287 1.793a1.102 1.102 0 010-1.485.939.939 0 011.39 0l6.034 6.45c.192.205.288.473.288.742s-.096.538-.288.743z" fill-rule="nonzero" />
      </svg>
    </a>
  </section>
</template>

<script>
import LazyImage from '@/components/LazyImage.vue'
import { NEWS_MORE_URL } from '@/utils/election2026/constants'
import { trackEvent } from '@/utils/election2026/tracking'

/**
 * 相關新聞區塊
 *
 * 主頁側欄、縣市詳情頁、新聞列表頁共用。
 * 資料來源為主站「2026九合一選舉」專題，格式由 service 層的 normalizeArticle 轉換
 * （見 utils/election2026/service.js 與契約 §7）。
 */
export default {
  name: 'Election2026NewsList',
  components: {
    LazyImage
  },
  props: {
    /**
     * 新聞陣列
     */
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '相關新聞'
    },
    /**
     * 「看更多」的目的地，預設為主站「2026九合一選舉」專題頁
     */
    moreLink: {
      type: String,
      default: NEWS_MORE_URL
    },
    /**
     * 是否顯示「看更多」。新聞列表頁本身不需要
     */
    showMore: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    /**
     * 點新聞。用於統計活動頁導流到文章的成效；
     * 點擊來自哪一頁由 GA4 自動帶的 page_location 判斷，不另外記縣市
     */
    trackNewsClick(item) {
      trackEvent(this, 'election_news_click', { label: item.title })
    },
    trackMoreClick() {
      trackEvent(this, 'election_news_more', { label: 'link' })
    }
  }
}
</script>
